"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IaArrangementUtil = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
class IaArrangementUtil {
    static isEvenOddAllowed(kette) {
        switch (kette.serieType) {
            case echain_shared_articles_1.KetteSerieType.default:
            case echain_shared_articles_1.KetteSerieType.twisterchain:
            case echain_shared_articles_1.KetteSerieType.rxRohr:
                return true;
            case echain_shared_articles_1.KetteSerieType.eskin:
            case echain_shared_articles_1.KetteSerieType.triflexR:
            case echain_shared_articles_1.KetteSerieType.trxe:
            case echain_shared_articles_1.KetteSerieType.twisterband:
            case echain_shared_articles_1.KetteSerieType.rolEchain:
                return false;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(kette.serieType);
        }
    }
}
exports.IaArrangementUtil = IaArrangementUtil;
IaArrangementUtil.className = 'IaArrangementUtil';
//# sourceMappingURL=IaArrangementUtil.js.map